import { Button, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useCallback, useEffect, useState } from 'react';

import { ModalProps } from 'models/CommonType';
import './ChatModal.css';

interface ChatModalProps extends ModalProps {
  chatUrl: string;
  title?: string;
}

const ChatModal: React.FC<ChatModalProps> = ({
  isOpen: open = false,
  closeHandler,
  chatUrl,
  title,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(open);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  const onClose = useCallback(() => {
    setIsOpen(false);
    closeHandler?.();
  }, [closeHandler]);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const modalTitle = title || '';

  if (isMobile) {
    return (
      <Modal
        title={null}
        open={isOpen}
        onCancel={onClose}
        footer={null}
        width="100vw"
        style={{ top: 0, padding: 0, maxWidth: 'none' }}
        className="chat-modal-mobile"
        destroyOnClose
      >
        <div className="chat-modal-mobile-header">
          <h3 className="chat-modal-mobile-title">{modalTitle}</h3>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={onClose}
            className="chat-modal-mobile-close"
          />
        </div>
        <div className="chat-modal-mobile-content">
          <iframe
            src={chatUrl}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
            }}
            frameBorder="0"
            allow="microphone"
            title={modalTitle}
          />
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      title={modalTitle}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={800}
      className="chat-modal-desktop"
      destroyOnClose
    >
      <div className="chat-modal-content">
        <iframe
          src={chatUrl}
          style={{
            width: '100%',
            height: '100%',
            minHeight: '700px',
            border: 'none',
          }}
          frameBorder="0"
          allow="microphone"
          title={modalTitle}
        />
      </div>
    </Modal>
  );
};

export default ChatModal;